import PubSub from "underpub-js";

var ContactBlock = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ContactBlock',
	};

	$.extend(true, this.options, options);

};

ContactBlock.prototype.init = function() {

	var self = this;

};

export default ContactBlock;
